import ApiService from './ApiService'

const ContractService = {
    get(contract) {
        return ApiService.get('contract.show', contract)
    },

    create(data) {
        return ApiService.post('contract.store', data)
    },

    update(contract, data) {
        return ApiService.post('contract.update_contract', data, contract)
    },

    delete(contract) {
        return ApiService.delete('contract.delete', contract)
    },

    updateCustomerUid(contract, data) {
        return ApiService.post('contract.update_customer_uid', data, contract)
    },

    updateNotes(contract, data) {
        return ApiService.post('contract.update_notes', data, contract)
    },

    updateCountersigningDate(contract, data) {
        return ApiService.post('contract.update_countersigning_date', data, contract)
    },

    updateFlexibilityLevel(contract, data) {
        return ApiService.post('contract.update_flexibility_level', data, contract)
    },

    previewOperatorChange(contract, data) {
        return ApiService.post('contract.preview_operator_change', data, contract)
    },

    updateOperator(contract, data) {
        return ApiService.post('contract.update_operator', data, contract)
    },

    addTemporaryContractFigure(contract, data) {
        return ApiService.post('contract.figure.store', data, contract)
    },

    deleteTemporaryContractFigure(tfc) {
        return ApiService.delete('contract.figure.delete', tfc)
    },

    requestApproval(contract) {
        return ApiService.get('contract.user_approve', contract)
    },

    approve(contract) {
        return ApiService.get('contract.approve', contract)
    },

    getChanges(contract) {
        return ApiService.get('contract.changes', contract)
    },

    shareContractsPreview(data) {
        return ApiService.post('contract.share.preview', data)
    },

    shareContracts(data) {
        return ApiService.post('contract.share', data)
    },

    unshareContract(data) {
        return ApiService.post('contract.unshare', data)
    },

    async downloadPdf(params) {
        return await ApiService.downloadFile('click_finance.pdf', null, params)
    },
}

export default ContractService
